import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ApplicationRef, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoaderInterceptor, AuthGuard } from './helpers';
import { NgSelect2Module } from 'ng-select2';
import { RouterModule, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgxSpinnerModule } from 'ngx-spinner';
import { RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor';
import { TextEditorSyncfusionComponent } from './Components/text-editor-syncfusion/text-editor-syncfusion.component';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    RouterOutlet,
    RouterModule,
    NgSelect2Module,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    RichTextEditorAllModule
  ],
  providers: [
    AuthGuard,
    LoaderInterceptor,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true }
  ],
  bootstrap: []
})
export class AppModule {
  constructor(private appRef: ApplicationRef) {}

  ngDoBootstrap() {
    const appComponent = this.appRef.bootstrap(AppComponent);
  }
}

